import React from 'react';
import { Helmet } from 'react-helmet-async';
import SectionHeading from '../Components/SectionHeading/SectionHeading';
import DoctorsSurveyForm from '../Components/DoctorsSurvey/DoctorsSurveyForm';
import { useLanguage } from '../contexts/LanguageContext';

const DoctorsSurveyPage = () => {
    const { t } = useLanguage();

    return (
        <>
            <Helmet>
                <title>{t('survey.meta.title')} | TerminTeiler</title>
                <meta name="description" content={t('survey.meta.description')} />
            </Helmet>

            <div className="st-height-b100 st-height-lg-b80" />

            <SectionHeading
                title={t('survey.page.title')}
                subTitle={t('survey.page.subtitle')}
            />

            <div className="container">
                <div className="row">
                    <div className="col-lg-10 offset-lg-1">
                        <DoctorsSurveyForm />
                    </div>
                </div>
            </div>

            <div className="st-height-b100 st-height-lg-b80" />
        </>
    );
};

export default DoctorsSurveyPage;
